import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './button';
import { ArrowLeft } from 'lucide-react';

const BackButton = ({ to = "/dashboard", label = "Espace Membre" }) => {
  return (
    <Link to={to}>
      <Button 
        variant="ghost" 
        className="text-purple-400 hover:text-purple-300 hover:bg-purple-900/30 mb-4"
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Retour à {label}
      </Button>
    </Link>
  );
};

export { BackButton };
